"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactMotion = require("react-motion");

var _core = require("@nivo/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const CrosshairLine = (0, _react.memo)(({
  x0,
  x1,
  y0,
  y1
}) => {
  const theme = (0, _core.useTheme)();

  const _useMotionConfig = (0, _core.useMotionConfig)(),
        animate = _useMotionConfig.animate,
        springConfig = _useMotionConfig.springConfig;

  const style = (0, _react.useMemo)(() => _extends({}, theme.crosshair.line, {
    pointerEvents: 'none'
  }), [theme.crosshair.line]);

  if (animate !== true) {
    return _react.default.createElement("line", {
      x1: x0,
      x2: x1,
      y1: y0,
      y2: y1,
      fill: "none",
      style: style
    });
  }

  return _react.default.createElement(_reactMotion.Motion, {
    style: {
      x0: (0, _reactMotion.spring)(x0, springConfig),
      x1: (0, _reactMotion.spring)(x1, springConfig),
      y0: (0, _reactMotion.spring)(y0, springConfig),
      y1: (0, _reactMotion.spring)(y1, springConfig)
    }
  }, line => _react.default.createElement("line", {
    x1: line.x0,
    x2: line.x1,
    y1: line.y0,
    y2: line.y1,
    fill: "none",
    style: style
  }));
});
CrosshairLine.displayName = 'CrosshairLine';
CrosshairLine.propTypes = process.env.NODE_ENV !== "production" ? {
  x0: _propTypes.default.number.isRequired,
  x1: _propTypes.default.number.isRequired,
  y0: _propTypes.default.number.isRequired,
  y1: _propTypes.default.number.isRequired
} : {};
var _default = CrosshairLine;
exports.default = _default;
module.exports = exports.default;